import { render, staticRenderFns } from "./FirstReviewer.vue?vue&type=template&id=5fb09669"
import script from "./FirstReviewer.vue?vue&type=script&lang=js"
export * from "./FirstReviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports